/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 08/12/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Validación de abono total contra entrega definitiva
*      3       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Selección de abono para reimpresión desde herramientas
*      4       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Reimpresión de abonos solo desde otras acciones
*      5       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Sincronización visual de status ENTREGADO desde contexto
*      6       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Menú de otras acciones fuera del banner principal
*      7       | 31/05/2026 | Lic. José Luis Aragón Cervantes  | Bloqueo inicial de acciones hasta cargar apartado
*      8       | 05/06/2026 | Lic. José Luis Aragón Cervantes  | Resalte visual de cliente y folio
*      9       | 05/06/2026 | Lic. José Luis Aragón Cervantes  | Compactación de ficha de apartado
* ---------------------------------------------------------------------------------------
*/

import TextField from "../ui/TextField";
import {
    apiBuscarEstadoCuenteClienteApartados,
} from "../../settings/ApiConfig.js"

import { Fragment, useEffect, useState, useRef } from 'react'
import { Tooltip } from "@mui/material";

import { getDateString } from "../../settings/utils.js"
import SizeSoftXLayoutForm from "../leyout/SizeSoftXLayoutForm"
import MnuApartadosActions from "./MnuApartadosActions"
import FrmListaApartadosDetalles from "./FrmListaApartadosDetalles"
import SizeSoftXTableVentas from "../leyout/SizeSoftXTableVentas"
import SemaforoStatus from "../utils/SemaforoStatus"
import ModalCobrosGenerales from "../ventas/ModalCobrosGenerales"
import ModalCambioCostoArticulo from "../ventas/ModalCambioCostoArticulo"
import ModalCancelacionApartados from "../ventas/ModalCancelacionApartados"
import SizeSoftXLoadingProcess from "../leyout/SizeSoftXLoadingProcess"
import MnuOtherActionsApartados from "./MnuOtherActionsApartados"

import { useRequest } from "../../context/System/RequestContext";
import { useVentas } from "../../context/Ventas/VentasContext"
import { useSesion } from '../../context/System/SesionContext'
import { useFormTabLock } from "../../hooks/useFormTabLock";

const getDataClient = () => ({
    fechaapartado: " ",
    clavecliente: " ",
    nombrecliente: " ",
    folioapartado: 0,
    montototalabonado: 0,
    listaapartados: [{
        idpartida: 0,
        clavearticulo: " ",
        descripcionarticulo: " ",
        medidaarticulo: 0,
        costocliente: 0,
        totalabonado: 0,
        nombrevendedor: " ",
    }]
});

const getTotalApartados = () => ({
    folioapartado: 0,
    idpartida: 0,
    montoabono: 0
});

const apartadoFieldSx = (width) => ({
    width,
    height: '42px',
    '& .MuiInputBase-root': {
        height: '38px',
    },
    '& .MuiInputBase-input': {
        padding: '6px 10px',
        fontSize: '0.95rem',
    },
});

const apartadoStrongFieldSx = (width) => ({
    ...apartadoFieldSx(width),
    '& .MuiInputBase-input': {
        padding: '10px 14px',
        fontSize: '1.2rem',
        fontWeight: 700,
    },
    '& .MuiInputLabel-root': {
        fontWeight: 700,
    },
});

export default function FrmApartados() {
    const { isLocked: isFormLocked } = useFormTabLock('apartados', {
        title: 'Apartados',
        onLockDetected: (info) => {
            console.warn(`El formulario de ${info?.title || 'Apartados'} ya está abierto en otra pestaña`);
        }
    });

    const { GetRequest } = useRequest()
    const { parametrosCajaForm } = useSesion();

    const [dataClient, setDataClient] = useState(getDataClient());
    const [partidaSeleccionada, setPartidaSeleccionada] = useState({});
    const [listaPartidasApartado, setListaPartidasApartado] = useState([]);
    const [statusModalCambioCosto, setStatusModalCambioCosto] = useState(false);
    const [dataApartados, setDataApartados] = useState([]);
    const [openOtherActions, setOpenOtherActions] = useState(false);

    const [dataEstadoCuenta, setDataEstadoCuenta] = useState({
        nombrecliente: "",
        apartados: [],
        abonos: [],
        totalabonado: 0,
    });

    const {
        openModalImpresion,
        setOpenModalImpresion,
        FrtTicketVentas,
        handleConsultaMontoLetra,
        handClickCobrarAbonoApartado,
        openModalCobrarAbonoApartado,
        setVentaTotales,
        ventaTotales,
        setStatusCobroApartado,
        setStatusActualApartado,
        handleCerrarModalGenerarAbonoApartados,
        handleCambiarCostoArticuloApartado,
        handleCerrarModalCambioCostoApartados,
        openModalCambioCostoApartado,
        openModalCancelarApartado,
        handleCerrarModalCancelarApartados,
        handleCancelarApartadoSubmit,
        statusWaiting,
        setDataEstadoCuentaApartado,
        dataEstadoCuentaApartado,
        setRowPartidaApartadoFind,
        setAbonoApartadoSeleccionado,
        handleClickEstadoCuentaCliente,
        handleClickRegresarMainDashboard,
        isModoEntregaDefinitiva,
    } = useVentas();

    const [totalApartados, setTotalApartados] = useState(getTotalApartados);
    const [costoArticulo, setCostoArticulo] = useState(0);

    const [rowPartidaFind, setRowPartidaFind] = useState({});

    useEffect(() => {
        setDataEstadoCuentaApartado({});
        setAbonoApartadoSeleccionado({});
        setRowPartidaApartadoFind({});
        setStatusActualApartado(false);
        setStatusCobroApartado(false);
    }, []);

    useEffect(() => {
        const apartadoContext = dataEstadoCuentaApartado?.apartados?.[0];
        const apartadoLocal = dataEstadoCuenta?.apartados?.[0];
        if (!apartadoContext || !apartadoLocal) return;

        const mismoFolio = Number(apartadoContext.folioapartado || 0) === Number(apartadoLocal.folioapartado || 0);
        const mismaPartida = Number(apartadoContext.idpartida || 0) === Number(apartadoLocal.idpartida || 0);
        const statusContext = (apartadoContext.status || '').toString().trim();
        const statusLocal = (apartadoLocal.status || '').toString().trim();
        if (!mismoFolio || !mismaPartida || statusContext === statusLocal) return;

        setDataEstadoCuenta(dataEstadoCuentaApartado);
        setDataApartados(dataEstadoCuentaApartado?.apartados || []);
        setListaPartidasApartado((prev) => prev.map((partida) => ({
            ...partida,
            statusapartado: statusContext,
        })));

        const statusUpper = statusContext.toUpperCase();
        const apartadoActivo = statusUpper !== 'CANCELADO' && statusUpper !== 'TR' && statusUpper !== 'ENTREGADO';
        setStatusActualApartado(apartadoActivo);
        setStatusCobroApartado(apartadoActivo);
    }, [dataEstadoCuentaApartado]);
    const inputFiltroClienteRef = useRef(null);

    const handleChangePartidaSeleccionada = (e) => {
        setPartidaSeleccionada(e);
        if (e?.iabono) {
            setAbonoApartadoSeleccionado(e);
        }
    };

    const handleRowFind = async (datarow) => {
        setRowPartidaFind(datarow);
        setRowPartidaApartadoFind(datarow);
        await handleCargarEstadoCuentaPartida(datarow);
    };

    const handleCargarEstadoCuentaPartida = async (data) => {
        let url = apiBuscarEstadoCuenteClienteApartados.replace("{nombrecliente}", data.nombrecliente.trim());
        url = url.replace("{folioapartado}", data.folioapartado);
        url = url.replace("{partida}", data.idpartida);

        const response = await GetRequest({
            url
        });

        if (response.hasError) {
            console.error("Error al cargar estado de cuenta:", response.message);
            setDataEstadoCuenta({});
            setDataEstadoCuentaApartado({});
            return;
        }

        if (!response?.result) {
            console.error("No se recibieron datos del estado de cuenta");
            setDataEstadoCuenta({});
            setDataEstadoCuentaApartado({});
            return;
        }

        const result = response.result;

        setDataEstadoCuenta(result);
        setDataEstadoCuentaApartado(result);
        setAbonoApartadoSeleccionado({});
        const status = (result?.apartados?.[0]?.status || '').trim().toUpperCase();
        setStatusActualApartado(status !== 'CANCELADO' && status !== 'TR' && status !== 'ENTREGADO');
        setStatusCobroApartado(status !== 'CANCELADO' && status !== 'TR' && status !== 'ENTREGADO');
        setDataApartados(result?.apartados || []);

        let totalMontoVentaApartadoPartida = result?.apartados?.[0]?.costoarticulo || 0;
        setCostoArticulo(totalMontoVentaApartadoPartida);
        const sumaMontosAbono = result?.abonos?.reduce((total, e) => total + (e.montoabono || 0), 0) || 0;
        totalMontoVentaApartadoPartida -= sumaMontosAbono;

        let montoEnLetra = "";
        montoEnLetra = await handleConsultaMontoLetra(totalMontoVentaApartadoPartida);

        setVentaTotales({
            ...ventaTotales,
            totalDescuento: 0,
            subTotal: totalMontoVentaApartadoPartida,
            totalIVA: totalMontoVentaApartadoPartida - (totalMontoVentaApartadoPartida / 1.16),
            total: totalMontoVentaApartadoPartida,
            montoEnLetra: montoEnLetra,
            folioapartado: data.folioapartado,
            idpartida: data.idpartida,
        });

        setListaPartidasApartado([]);
        const nuevaLista = [];
        let abonoIndex = 0;
        (result?.apartados || []).forEach((apartado) => {
            (result?.abonos || []).forEach((abono) => {
                abonoIndex++;
                nuevaLista.push({
                    id: `abono_${abonoIndex}`,
                    clavearticulo: (apartado.clavearticulo || '').toString().trim(),
                    descripcion: (apartado.descripcion || '').toString().trim(),
                    medida:apartado.medida,
                    cantidad:apartado.cantidadarticulo,
                    costocliente:apartado.costoarticulo,
                    idpartida:apartado.idpartida,
                    partida: abonoIndex,
                    montoabono:abono.montoabono,
                    fechaabono:getDateString(abono.fecharegistro),
                    iabono:abono.abono,
                    folioapartado:apartado.folioapartado,
                    totalarticulo:apartado.cantidadarticulo * apartado.costoarticulo,
                    statusapartado:apartado.status ? (apartado.status || '').toString().trim() : "",
                });
            });
        });
        setListaPartidasApartado(nuevaLista);
        if (nuevaLista.length > 0) {
            const statusApartado = nuevaLista[0].statusapartado;
            const statusUpper = statusApartado ? statusApartado.toString().trim().toUpperCase() : "";
            setStatusCobroApartado(statusUpper !== 'CANCELADO' && statusUpper !== 'TR' && statusUpper !== 'ENTREGADO');
        }
    };

    const handleIniciarCobro = async (e) => {
        await handClickCobrarAbonoApartado(e);
        await handleCargarEstadoCuentaPartida(rowPartidaFind);
    };

    const handleAplicarDescuentoArticulo = async ({ nuevoCosto, nuevoDescuento }) => {
        const data = {
            folioapartado: dataApartados[0].folioapartado,
            idpartida: dataApartados[0].idpartida,
            clavearticulo: dataApartados[0].clavearticulo,
            medida: dataApartados[0].medida,
            cantidadarticulo: dataApartados[0].cantidadarticulo,
            costoarticulo: nuevoCosto,
            montodescuentoarticulo: nuevoDescuento,
        };

        await handleCambiarCostoArticuloApartado(data);
        await handleCargarEstadoCuentaPartida(rowPartidaFind);
    };

    const handleCancelarApartadoMain = async (data) => {
        await handleCancelarApartadoSubmit(data);
        await handleCargarEstadoCuentaPartida(rowPartidaFind);
    };


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key.trim().toUpperCase() === "F4") {
                event.preventDefault();
                event.stopPropagation();
                handleClickRegresarMainDashboard();
                return;
            }

            if (event.altKey && event.key.trim().toUpperCase() === "F1") {
                event.preventDefault();
                event.stopPropagation();

                if (inputFiltroClienteRef.current) {
                    inputFiltroClienteRef.current.focus();
                    inputFiltroClienteRef.current.select();
                }

                return;
            }

            if (event.altKey && event.key.trim().toUpperCase() === "I") {
                event.preventDefault();
                event.stopPropagation();

                handleClickEstadoCuentaCliente();
                return;
            }
        };

        window.addEventListener("keydown", handleKeyDown);
        return () => window.removeEventListener("keydown", handleKeyDown);
    }, []);

    useEffect(() => {
        if (isFormLocked) {
            alert("El formulario de Apartados ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.");
            setTimeout(() => {
                handleClickRegresarMainDashboard();
            }, 900);
        }
    }, [isFormLocked]);

    return (
        <>
            <Fragment>
                <SizeSoftXLayoutForm
                    titlePage="Módulo de apartados"
                    buttonActions={<MnuApartadosActions onOpenOtherActions={() => setOpenOtherActions(true)} />}
                >
                    <div className="conteiner-form-Apartados apartados-scroll-layout">
                        <div className="conteiner-form-left-Apartados apartados-scroll-filtro">
                            <FrmListaApartadosDetalles
                                rowApartado={handleRowFind}
                                inputFocusRef={inputFiltroClienteRef}
                            />
                        </div>
                        <div className="conteiner-form-rigth-Apartados apartados-scroll-detalles">
                            <div className="body-form-Apartados" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '12px' }}>
                                <TextField autoComplete="off"
                                    name="NombreCliente"
                                    label="Nombre cliente:"
                                    value={dataEstadoCuenta.nombrecliente ? dataEstadoCuenta.nombrecliente : ""}
                                    sx={apartadoStrongFieldSx('50%')}
                                    disabled
                                />
                                <SemaforoStatus
                                    status={listaPartidasApartado.length > 0 && listaPartidasApartado[0]?.statusapartado ? listaPartidasApartado[0].statusapartado : ""}
                                />
                            </div>
                            <div className="body-form-Apartados">
                                <TextField autoComplete="off"
                                    name="FechaApartado"
                                    label="Fecha:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? getDateString(dataEstadoCuenta.apartados[0].fecharegistro)
                                            : ""
                                    }
                                    sx={apartadoFieldSx('220px')}
                                    disabled
                                />
                                <TextField autoComplete="off"
                                    name="idApartado"
                                    label="Folio:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? dataEstadoCuenta.apartados[0].folioapartado
                                            : ""
                                    }
                                    sx={apartadoStrongFieldSx('90px')}
                                    disabled
                                />
                                <TextField autoComplete="off"
                                    name="idPartida"
                                    label="Partida:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? dataEstadoCuenta.apartados[0].idpartida
                                            : 0
                                    }
                                    sx={apartadoFieldSx('82px')}
                                    disabled
                                />
                                <Tooltip
                                    title={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? `Descripción: ${dataEstadoCuenta.apartados[0].descripcion}`
                                            : "Descripción:"
                                    }
                                    arrow
                                >
                                    <TextField autoComplete="off"
                                        name="descripcion"
                                        label="Descripción:"
                                        value={
                                            dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                                ? dataEstadoCuenta.apartados[0].descripcion
                                                : ""
                                        }
                                        sx={apartadoFieldSx('240px')}
                                        disabled
                                    />
                                </Tooltip>
                                <TextField autoComplete="off"
                                    name="medida"
                                    label="Medida:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? dataEstadoCuenta.apartados[0].medida
                                            : ""
                                    }
                                    sx={apartadoFieldSx('110px')}
                                    disabled
                                />
                            </div>
                            <div className="body-form-Apartados">
                                <TextField autoComplete="off"
                                    name="cantidadarticulo"
                                    label="Cantidad:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? dataEstadoCuenta.apartados[0].cantidadarticulo
                                            : ""
                                    }
                                    sx={apartadoFieldSx('160px')}
                                    disabled
                                />
                                <TextField autoComplete="off"
                                    name="costoarticulo"
                                    label="Costo U.:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? dataEstadoCuenta.apartados[0].costoarticulo
                                            : ""
                                    }
                                    sx={apartadoFieldSx('160px')}
                                    disabled
                                />
                                <TextField autoComplete="off"
                                    name="totalarticulo"
                                    label="Total:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? dataEstadoCuenta.apartados[0].costoarticulo * dataEstadoCuenta.apartados[0].cantidadarticulo
                                            : ""
                                    }
                                    sx={apartadoFieldSx('160px')}
                                    disabled
                                />
                                <TextField autoComplete="off"
                                    name="MontoAbonado"
                                    label="Monto total abonos:"
                                    value={dataEstadoCuenta.totalabonado ? dataEstadoCuenta.totalabonado : 0}
                                    sx={apartadoFieldSx('180px')}
                                    disabled
                                />
                                <TextField autoComplete="off"
                                    name="MontoRestante"
                                    label="Restante:"
                                    value={
                                        dataEstadoCuenta.apartados && dataEstadoCuenta.apartados.length > 0
                                            ? Math.max(
                                                (dataEstadoCuenta.apartados[0].costoarticulo * dataEstadoCuenta.apartados[0].cantidadarticulo)
                                                - Number(dataEstadoCuenta.totalabonado || 0), 0)
                                            : ""
                                    }
                                    sx={apartadoStrongFieldSx('160px')}
                                    disabled
                                />
                            </div>
                            <div className="body-child-Apartados">
                                <SizeSoftXTableVentas
                                    columns={[
                                        { title: "Partida", field: "partida" },
                                        { title: "Monto abono", field: "montoabono" },
                                        { title: "Fecha abono", field: "fechaabono" },
                                        { title: "Folio abono", field: "iabono" },
                                    ]}
                                    data={listaPartidasApartado == null ? [] : listaPartidasApartado}
                                    id="id"
                                    row={partidaSeleccionada}
                                    setRow={handleChangePartidaSeleccionada}
                                    fontSize="Sismall"
                                    rowsPerPageIntro={50}
                                />
                            </div>
                        </div>
                    </div>
                    <ModalCobrosGenerales
                        openModalCobrarVentas={openModalCobrarAbonoApartado}
                        montosVenta={ventaTotales}
                        setMontosVenta={setVentaTotales}
                        handleCloseModalCobroVentas={handleCerrarModalGenerarAbonoApartados}
                        handleCobrar={handleIniciarCobro}
                        modoEntregaDefinitiva={isModoEntregaDefinitiva}
                        bloquearCobroTotalSimple={true}
                        calcularCambioEnLetra={false}
                    />
                    <ModalCambioCostoArticulo
                        openModalCambioCosto={openModalCambioCostoApartado}
                        costoArticulo={costoArticulo}
                        descuentoArticulo={dataApartados[0]?.montodescuentoarticulo || 0}
                        handleCloseModalCambioCosto={handleCerrarModalCambioCostoApartados}
                        handleCambiarCosto={handleAplicarDescuentoArticulo}
                    />
                    <ModalCancelacionApartados
                        openModalCancelacionApartado={openModalCancelarApartado}
                        datosApartado={rowPartidaFind}
                        handleCloseModalCancelacionApartados={handleCerrarModalCancelarApartados}
                        handleCancelarApartado={handleCancelarApartadoMain}
                    />
                    <MnuOtherActionsApartados
                        open={openOtherActions}
                        onClose={() => setOpenOtherActions(false)}
                    />
                </SizeSoftXLayoutForm>
                <SizeSoftXLoadingProcess
                    open={statusWaiting} message="Procesando información, por favor espere..."
                />
            </Fragment>
        </>
    )
}
